import React, { useState, useEffect } from 'react';
import { Box, View } from '@common/components';
import { path0203, door0202, door00, puzzle0203 } from '../assets/images';
import { connect } from 'react-redux';
import { setNavigation } from '@resources/Navigation/actions';
import ImageMapper from 'react-image-mapper';
import { Col, Row, Modal, message } from 'antd';
import CombinationLock from 'combination-lock-react';
import { addPuzzle, updatePuzzle } from '@resources/Puzzle/actions';
import { addClue } from '@resources/Clue/actions';
import { doAction } from '@resources/Action/actions';
import { cluesConfig, puzzlesConfig } from '../config';
import { getCookie } from '@common/utils/cookie';
import { isEmpty } from 'lodash';
import { CheckCircleFilled } from '@ant-design/icons';
import { updateMember } from '@resources/Member/actions';
import { Redirect } from 'react-router-dom';
import { addSolve } from '@resources/Solve/actions';
import Help from '@games/BataviaExpress/fragments/Help';

const MrFleddoes = ({
  setNavigation,
  socket,
  solves,
  match,
  history,
  doAction,
  addClue,
  addPuzzle,
  addSolve,
  clues,
  updateMember,
}) => {
  const u = getCookie('user') ? JSON.parse(getCookie('user')) : {};
  const location = 'Mr Fleddoes Room';
  const [visiblePuzzle0203, setVisiblePuzzle0203] = useState(false);
  const { params } = match || {};
  const { channelId } = params;
  const width = 2000;
  const height = 1407;
  const cluesConf = cluesConfig(channelId);
  const puzzlesConf = puzzlesConfig(channelId);
  // const solvedPuzzles = getCookie('solved')
  // 	? JSON.parse(getCookie('solved'))
  // 	: [];

  const MAP = {
    name: 'my-map',
    areas: [
      {
        name: 'puzzle0203',
        shape: 'poly',
        coords: [248, 194, 432, 199, 432, 293, 242, 293],
      },
    ],
  };

  if (solves.filter((solve) => solve === '0202').length === 0) {
    return (
      <Redirect to={`/batavia-express/${channelId}/play/agatha-godsson`} />
    );
  }

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname ===
        `/batavia-express/${channelId}/play/mr-fleddoes`
    ) {
      if (!isEmpty(socket)) {
        doAction({
          game: 'batavia-express',
          channel: socket.channel,
          event: 'member',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            game: 'batavia-express',
          },
        });
        doAction({
          game: 'batavia-express',
          channel: socket.channel,
          event: 'log',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            channel: channelId,
            message: `has moved to ${location}`,
            game: 'batavia-express',
          },
        });
        updateMember({ id: socket.id, name: u.name, location });
        // doAction({
        // 	channel: socket.channel,
        // 	event: 'clues',
        // 	message: clues,
        // });
      }
    }
  }, [socket, history]);

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname ===
        `/batavia-express/${channelId}/play/mr-fleddoes`
    ) {
      setNavigation({
        backward: {
          title: "Agatha Godsson's Room",
          onPress: () => {
            history.push(`/batavia-express/${channelId}/play/agatha-godsson`);
          },
          image: door0202,
        },
        forward: {
          title: 'Hallway',
          locked: solves.filter((solve) => solve === '0203').length === 0,
          image: door00,
          onPress: () => {
            history.push(`/batavia-express/${channelId}/play/fork`);
          },
        },
      });
    }
  }, [clues, solves, history]);

  const handleClick = (area) => {
    if (area.name === 'puzzle0203') {
      addPuzzle({
        ...puzzlesConf.puzzle0203,
        status: 'unsolved',
      });

      doAction({
        game: 'batavia-express',
        channel: socket.channel,
        event: 'log',
        message: {
          id: socket.id,
          name: u.name,
          location: location,
          channel: channelId,
          message: 'has opened the Mr Fleddoes puzzle',
          game: 'batavia-express',
        },
      });
      setVisiblePuzzle0203(true);
    }
  };

  return (
    <View>
      <Box textAlign="center">
        <ImageMapper
          src={path0203}
          width={window.innerWidth}
          height={(window.innerWidth * height) / width}
          map={MAP}
          imgWidth={width}
          onClick={handleClick}
        />
      </Box>
      <Modal
        visible={visiblePuzzle0203}
        onCancel={() => {
          doAction({
            game: 'batavia-express',
            channel: socket.channel,
            event: 'log',
            message: {
              id: socket.id,
              name: u.name,
              location: location,
              channel: channelId,
              message: 'has closed the Mr Fleddoes puzzle',
              game: 'batavia-express',
            },
          });
          setVisiblePuzzle0203(false);
        }}
        width={800}
        footer={null}
      >
        <Row gutter={24}>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <img src={puzzle0203} alt="Puzzle" />
          </Col>
          <Col xs={24}>
            <br />
            <br />
            <Box textAlign="center">
              {solves.filter((solve) => solve === '0203').length === 0 ? (
                <>
                  You need to solve the puzzle above and use the answer
                  combination to open the lock below
                  <br />
                  <br />
                  <Box width="100%">
                    <CombinationLock
                      style={{ color: '#333' }}
                      combination="179"
                      height={70}
                      onMatch={() => {
                        message.success(
                          "Congrats! You have solved the puzzle for this room and found a clue + the back cover of Naga Mas's Notebook! You may proceed to the next room"
                        );
                        addSolve('0203');
                        doAction({
                          game: 'batavia-express',
                          channel: socket.channel,
                          event: 'notification',
                          message: {
                            type: 'success',
                            title: 'Mr Fleddoes Puzzle Solved',
                            description: `Your team member ${
                              u.name ? u.name : ''
                            } has successfully solved the puzzle in Mr Fleddoes's room and found a clue + the back cover of Naga Mas's Notebook! Path 02 is now completed.`,
                            game: 'batavia-express',
                          },
                        });
                        doAction({
                          game: 'batavia-express',
                          channel: socket.channel,
                          event: 'solved',
                          message: {
                            puzzle: '0203',
                            channel: channelId,
                            game: 'batavia-express',
                          },
                        });
                        doAction({
                          game: 'batavia-express',
                          channel: socket.channel,
                          event: 'log',
                          type: 'solved',
                          message: {
                            id: socket.id,
                            name: u.name,
                            location: location,
                            channel: channelId,
                            puzzle: '0203',
                            message: 'has solved the Mr Fleddoes Room puzzle',
                            game: 'batavia-express',
                          },
                        });
                        addClue({
                          ...cluesConf.clue0203,
                        });
                        updatePuzzle({
                          ...puzzlesConf.puzzle0203,
                          status: 'solved',
                        });
                        setNavigation({
                          backward: {
                            onPress: () => {
                              history.push(
                                `/batavia-express/${channelId}/play/agatha-godsson`
                              );
                            },
                            content: door0202,
                          },
                          forward: {
                            image: door00,
                            onPress: () => {
                              history.push(
                                `/batavia-express/${channelId}/play/fork`
                              );
                            },
                          },
                        });
                      }}
                      openText={'Unlocked!'}
                    />
                  </Box>
                  <br />
                  <br />
                  <Help
                    location={location}
                    puzzle="0203"
                    channel={channelId}
                    solution={
                      <Box>
                        <strong>Hint</strong>
                        <br />
                        Find the color ticket stubs in the room and use the list
                        of ticket stubs on Naga Mas's notebook to determine the
                        3 digits you need to solve the puzzle
                        <br />
                        <br />
                        The sequence of the digits is determined by Batavia
                        Express route.
                      </Box>
                    }
                  />
                </>
              ) : (
                <>
                  Your team has successfully solved this puzzle and found a clue
                  in this room
                  <br />
                  <br />
                  <CheckCircleFilled
                    style={{
                      fontSize: 100,
                      color: '#52c41a',
                    }}
                  />
                </>
              )}
            </Box>
          </Col>
        </Row>
      </Modal>
    </View>
  );
};

const mapStateToProps = (state) => ({
  puzzles: state.puzzles,
  socket: state.socket,
  clues: state.clues,
  solves: state.solves,
});

export default connect(mapStateToProps, {
  doAction,
  addPuzzle,
  addClue,
  setNavigation,
  updateMember,
  addSolve,
})(MrFleddoes);
